export const dict = {
  en: {
    appName: "Flores Relief",
    tagline: "Together for Flores 7.7 Earthquake Recovery",
    nav: { dashboard: "Home", beneficiaries: "People", resources: "Resources", submit: "Submit", login: "Admin", logout: "Logout" },
    search: { placeholder: "Search a district, city, PIC, or need..." },
    dashboard: {
      title: "Together for Flores.",
      subtitle: "A live snapshot of everything happening across the relief effort — one tap and you're there.",
      stats: {
        people_helped: "People Helped",
        people_total: "People Registered",
        beneficiaries: "Locations",
        donors: "Donors",
        resources: "Resources Ready",
        drop_points: "Drop Points",
        pending: "Pending",
        in_progress: "In Progress",
        helped: "Fully Helped",
        kabupaten: "Regencies",
        kota: "Cities",
        money_raised: "Money Raised",
        goods_pledges: "Goods Pledged",
        fulfillment_rate: "Avg. Fulfillment",
        items: "Items",
        vendors: "Vendors",
        transport: "Transport",
        logistics: "Logistics",
      },
      byRegion: "People per Region",
      status: "Status Breakdown",
      news: "Live News · Flores Earthquake",
      newsEmpty: "No news right now. Please check again later.",
      topNeeds: "Most Requested",
      snippetPeople: "Latest people needing help",
      snippetResources: "Ready-to-send resources",
      snippetSubmit: "Get involved",
      snippetSubmitBody: "Ask for help or offer help in under a minute.",
      viewAll: "View all →",
    },
    beneficiaries: {
      title: "People Who Need Help",
      subtitle: "Interactive table with real progress per need. Click a row to expand.",
      add: "Add",
      empty: "No records match your search.",
      transparency: "Transparency: how much each family has been helped.",
      fields: {
        kabupaten: "Regency", kota: "City", pic_name: "PIC Name",
        pic_number: "Contact", people_count: "People", needs: "Needs",
        details: "Details", help_provided: "Help Provided", status: "Status",
        progress: "Progress"
      },
      statuses: { pending: "Pending", in_progress: "In Progress", helped: "Fully Helped" },
      needStatus: { pending: "Not yet", partial: "Partial", fulfilled: "Fulfilled" },
      addNeed: "Add Need",
      removeNeed: "Remove",
      requestedQty: "Requested",
      fulfilledQty: "Fulfilled",
      filterAll: "All",
      share: "Share",
      copyLink: "Copy Link",
      linkCopied: "Link copied",
      shareWhatsApp: "Share on WhatsApp",
      shareMessage: "Help needed: {pic} in {kota}, {kabupaten} — {people} people. Track progress:",
    },
    resources: {
      title: "Our Resources",
      subtitle: "Interactive table of everything we have ready to send.",
      add: "Add",
      empty: "No resources yet.",
      searchPlaceholder: "Search resources, locations, vendors...",
      tabs: { all: "All", donation: "Donations", item: "Items", vendor: "Vendors", transport: "Transport", logistic: "Logistics", drop_point: "Drop Points" },
      fields: { name: "Name", quantity: "Label / Description", quantity_total: "Total", quantity_delivered: "Delivered", contact: "Contact", location: "Location", notes: "Notes", category: "Category", progress: "Progress", remaining: "Left" },
    },
    submit: {
      title: "Submission",
      subtitle: "Ask for help, or offer help. It only takes a minute.",
      tabs: { receiver: "I Need Help", donor: "I Want to Donate" },
      donor: {
        name: "Your Name", contact: "Phone or Email", type: "Type of Donation",
        money: "Money", goods: "Goods", amount: "Amount (Rp)",
        items: "What items will you donate?",
        drop: "Choose Drop Point", bank: "Please transfer to:",
        agreement: "I confirm that my donation is safe, in good condition, and contains no dangerous or suspicious items.",
        submit: "Submit Donation",
        success: "Thank you! Your donation was submitted."
      },
      receiver: {
        needs: "What do you need?", submit: "Submit Request",
        success: "Your request has been received. We will follow up soon."
      }
    },
    login: { title: "Admin Login", email: "Email", username: "Username", password: "Password", submit: "Sign In", error: "Invalid username or password" },
    admin: { edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel", confirmDelete: "Delete this record?" }
  },
  id: {
    appName: "Flores Peduli",
    tagline: "Bersama untuk Pemulihan Gempa Flores 7.7",
    nav: { dashboard: "Beranda", beneficiaries: "Warga", resources: "Sumber Daya", submit: "Formulir", login: "Admin", logout: "Keluar" },
    search: { placeholder: "Cari kabupaten, kota, PIC, atau kebutuhan..." },
    dashboard: {
      title: "Bersama untuk Flores.",
      subtitle: "Ringkasan langsung dari seluruh kegiatan bantuan — satu klik, langsung ke halaman terkait.",
      stats: {
        people_helped: "Warga Terbantu Penuh",
        people_total: "Warga Terdata",
        beneficiaries: "Lokasi",
        donors: "Donatur",
        resources: "Sumber Daya Siap",
        drop_points: "Titik Drop",
        pending: "Menunggu",
        in_progress: "Berjalan",
        helped: "Terbantu Penuh",
        kabupaten: "Kabupaten",
        kota: "Kota",
        money_raised: "Dana Terkumpul",
        goods_pledges: "Barang Didonasikan",
        fulfillment_rate: "Rata-rata Pemenuhan",
        items: "Barang",
        vendors: "Vendor",
        transport: "Transportasi",
        logistics: "Logistik",
      },
      byRegion: "Warga per Wilayah",
      status: "Rincian Status",
      news: "Berita Langsung · Gempa Flores",
      newsEmpty: "Belum ada berita saat ini. Silakan cek kembali nanti.",
      topNeeds: "Paling Dibutuhkan",
      snippetPeople: "Warga terbaru yang membutuhkan",
      snippetResources: "Sumber daya siap kirim",
      snippetSubmit: "Ikut bantu",
      snippetSubmitBody: "Minta bantuan atau kirim donasi dalam kurang dari satu menit.",
      viewAll: "Lihat semua →",
    },
    beneficiaries: {
      title: "Warga yang Membutuhkan",
      subtitle: "Tabel interaktif dengan progres nyata per kebutuhan. Klik baris untuk detail.",
      add: "Tambah",
      empty: "Tidak ada data yang cocok.",
      transparency: "Transparansi: seberapa banyak tiap keluarga sudah dibantu.",
      fields: {
        kabupaten: "Kabupaten", kota: "Kota", pic_name: "Nama PIC",
        pic_number: "Kontak", people_count: "Orang", needs: "Kebutuhan",
        details: "Detail", help_provided: "Bantuan Diberikan", status: "Status",
        progress: "Progres"
      },
      statuses: { pending: "Menunggu", in_progress: "Berjalan", helped: "Terbantu Penuh" },
      needStatus: { pending: "Belum", partial: "Sebagian", fulfilled: "Lunas" },
      addNeed: "Tambah Kebutuhan",
      removeNeed: "Hapus",
      requestedQty: "Diminta",
      fulfilledQty: "Terpenuhi",
      filterAll: "Semua",
      share: "Bagikan",
      copyLink: "Salin Tautan",
      linkCopied: "Tautan disalin",
      shareWhatsApp: "Bagikan via WhatsApp",
      shareMessage: "Butuh bantuan: {pic} di {kota}, {kabupaten} — {people} jiwa. Pantau progres:",
    },
    resources: {
      title: "Sumber Daya Kami",
      subtitle: "Tabel interaktif semua yang siap kami kirim.",
      add: "Tambah",
      empty: "Belum ada data.",
      searchPlaceholder: "Cari sumber, lokasi, vendor...",
      tabs: { all: "Semua", donation: "Donasi", item: "Barang", vendor: "Vendor", transport: "Transportasi", logistic: "Logistik", drop_point: "Titik Drop" },
      fields: { name: "Nama", quantity: "Label / Keterangan", quantity_total: "Total", quantity_delivered: "Terkirim", contact: "Kontak", location: "Lokasi", notes: "Catatan", category: "Kategori", progress: "Progres", remaining: "Sisa" },
    },
    submit: {
      title: "Formulir",
      subtitle: "Mintalah bantuan, atau berikan bantuan. Hanya butuh satu menit.",
      tabs: { receiver: "Saya Butuh Bantuan", donor: "Saya Ingin Donasi" },
      donor: {
        name: "Nama Anda", contact: "Telepon atau Email", type: "Jenis Donasi",
        money: "Uang", goods: "Barang", amount: "Nominal (Rp)",
        items: "Barang apa yang akan didonasikan?",
        drop: "Pilih Titik Drop", bank: "Silakan transfer ke:",
        agreement: "Saya menyatakan barang yang didonasikan layak pakai dan tidak mengandung unsur berbahaya atau mencurigakan.",
        submit: "Kirim Donasi",
        success: "Terima kasih! Donasi Anda telah dikirim."
      },
      receiver: {
        needs: "Apa yang Anda butuhkan?", submit: "Kirim Permintaan",
        success: "Permintaan Anda telah diterima. Kami akan segera menghubungi."
      }
    },
    login: { title: "Login Admin", email: "Email", username: "Username", password: "Password", submit: "Masuk", error: "Username atau password salah" },
    admin: { edit: "Edit", delete: "Hapus", save: "Simpan", cancel: "Batal", confirmDelete: "Hapus data ini?" }
  }
};
